/* src/components/Portfolio.jsx */
import React from "react"
import PortfolioSlider from "./PortfolioSlider"
import SEO from "./SEO.jsx"
import PageHero from "./page/PageHero.jsx"

export default function Portfolio() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <SEO
        title="Clients | 2merative Web Design"
        description="It is our pleasure to partner with small to medium businesses to build and improve their online presence, including website delivery and Google Business Profile support."
        path="/portfolio"
        image="/og-image.png"
      />
      <PageHero
        eyebrow="Recent work"
        title="Our client work"
        lead="We work with established businesses and organisations across construction and trades, professional services, health and wellness, hospitality, retail and the community sector, delivering fast, modern websites and local search visibility."
        showCtas={false}
      />
      <div className="pb-32 px-4 sm:px-6">
        <PortfolioSlider />
      </div>
    </div>
  )
}
